module.exports = __webpack_public_path__ + "static/media/banner.d0ddce21.png";